import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function MAListReferenceComponents({ handleDrawerToggle, onActive }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/reference/component-customization/component-customization-overview'}
                onClick={handleDrawerToggle}
                secondary={'Overview'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/reference/component-customization/advanced-features'}
                onClick={handleDrawerToggle}
                secondary={'Advanced Features'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/reference/component-customization/component-keywords'}
                onClick={handleDrawerToggle}
                secondary={'Component Keywords'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/reference/component-customization/component-keyword-tables'}
                onClick={handleDrawerToggle}
                secondary={'Keyword Tables'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/reference/component-customization/component-scripts'}
                onClick={handleDrawerToggle}
                secondary={'Component Scripts'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/reference/component-customization/component-tutorial'}
                onClick={handleDrawerToggle}
                secondary={'Tutorial'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/reference/component-customization/perl-modules'}
                onClick={handleDrawerToggle}
                secondary={'Perl Modules'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/manager-agents/reference/component-customization/script-library'}
                onClick={handleDrawerToggle}
                secondary={'Script Library'}
            />
        </List>
    );
}

MAListReferenceComponents.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default MAListReferenceComponents;
